import { Checkbox, makeStyles } from "@material-ui/core";
import { useMoveDrawerContext, useMoveFormContext } from "../inventory-context";

const useStyles = makeStyles({
  checkbox: {
    padding: 0,
  },
});

export type Props = {
  lotId: string;
  name: string;
  locationId: string;
  locationName: string;
  expiryDate: string;
  quantity: number;
  externalReferences?: ReadonlyArray<{ origin: string }>;
  "data-testid"?: string;
};

export function MoveLotCheckbox({
  lotId,
  name,
  locationId,
  locationName,
  expiryDate,
  quantity,
  externalReferences,
  ...props
}: Props) {
  const { showCheckboxes } = useMoveDrawerContext();
  const { isLotSelected, handleLotClick } = useMoveFormContext();
  const classes = useStyles();

  return showCheckboxes ? (
    <Checkbox
      className={classes.checkbox}
      inputProps={{
        "data-testid": props["data-testid"] || "move-lots-checkbox",
      }}
      checked={isLotSelected(lotId)}
      onChange={() =>
        handleLotClick({
          key: lotId,
          sourceLotId: lotId,
          name,
          locationId,
          locationName,
          expiryDate,
          currentLotQuantity: quantity,
          externalReferences,
        })
      }
    />
  ) : null;
}
